<template style="">
  <div class="Game_a_type">

    <div v-if="!judgment" style="width: 100%;height: 100%;">
      <el-row :gutter="20">
        <el-col :span="20">
          <div class="grid-content bg-purple Game_a_type_left">
            <div class="Game_table">
              <table>
                <tr v-for="(iten, i) in fengeshuju" :key="i"> 
                  <td v-for="(it, j) in iten" :key="j"  @click="myLabClick(i, j)">
                    <span v-if="it.sta == '1'"  style="background-color: #75c5f0;height: 100%;width: 100%;display: inline-block;">{{ it.num }}</span>
                    <span v-else-if="it.sta == '2'"  style="background-color: rgb(6, 125, 64);height: 100%;width: 100%;display: inline-block;">{{ it.num }}</span>
                    <span v-else-if="it.sta == '3'" style="background-color: rgb(184, 184, 189);height: 100%;width: 100%;display: inline-block;">{{ it.num }}</span>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </el-col>

        <el-col :span="4">
          <div style="height: 100%;" class="grid-content bg-purple">
            <ul class="Game_a_type_right">

              <li>
                <h3 style="text-align: center;padding-top: 30px;color: rgba(201,162,88,1);">数字方格</h3>
                <p style="text-align: left;margin-left: 20px;margin-top: 15px; color: rgba(201,162,88,1);">难度：自定义</p>
                <p style="text-align: left;margin-left: 20px;margin-top: 15px; color: rgba(201,162,88,1);">状态：训练进行中</p>
                <p style="text-align: left;margin-left: 20px;margin-top: 15px; color: rgba(201,162,88,1);">错误：{{ myFaultCount }}</p>
              </li>

              <li>
                <h3 style="text-align: center;padding-top: 55px;color: rgba(201,162,88,1);">
                  <p>剩余时间</p>
                  <p style="font-size: 24px;color: red;margin-top: 20px;">{{ myTime }}</p>
                </h3>
              </li>

              <li>
                <p style="text-align: center;padding-top:50px;"><el-button type="primary" @click="Startover()">重新开始</el-button></p>
                <p style="text-align: center;margin-top: 20px;"><el-button type="primary">难度选择</el-button></p>
                <p style="text-align: center;margin-top: 20px;"><el-button type="primary">退出    </el-button></p>
              </li>

            </ul>
          </div>
        </el-col>
      </el-row>
    </div>

    <div class="cue" v-else>

      <div v-if="start_judgment" class="cue_nav">

        <div class="cue_nav_left">
          <img src='../../assets/vdvdv.png' alt="">
        </div>
        <div class="cue_nav_right"> 
          <h2>颜色速配</h2>
          <p>训练描述:</p>
          <p>在规定时间内，给出4个由不同颜色、文字组成的图片，看字与图片的颜色是否匹配，将不匹配的图片挑选出来，然后进行下一组。</p>
          <el-button type="primary" @click="start()">开始训练</el-button>
        </div>
      </div>
      <div v-else class="difficulty">
        <div class="difficulty_bac">

          <p class="difficulty_x">难度选择</p>

          <div @click="mgebtn" class="difficulty_standard" :class="{ 'Color': mgeColor }">
            <p>标准选择</p>
          </div>

          <div @click="pwdbtn" class="difficulty_customize" :class="{ 'Color': pwdColor }">
            <p>自定义</p>
          </div>

          <table v-if="zidingyi_judgment">

            <tr class="myTrTop">
              <th>难度</th>
              <th>数字个数</th>
              <th>训练时间</th>
            </tr>

            <tr class="myTrTwo" @click="Bccolor_switch(1)" :class="{'Bccolor': trbc == 1 }">
              <td class="myTdFont" style="width: 26%;">正常</td>
              <td class="myTdFont">1</td>
              <td class="myTdFont">33</td>
            </tr>

            <tr class="myTrTwo" @click="Bccolor_switch(2)" :class="{'Bccolor': trbc == 2 }">
              <td class="myTdFont" style="width: 26%;">简单</td>
              <td class="myTdFont">2</td>
              <td class="myTdFont">33</td>
            </tr>

            <tr class="myTrTwo" @click="Bccolor_switch(3)" :class="{'Bccolor': trbc == 3 }">
              <td class="myTdFont" style="width: 26%;">困难</td>
              <td class="myTdFont">3</td>
              <td class="myTdFont">33</td>
            </tr>
            
          </table>

          <div v-else>
            <el-form label-width="80px" :model="formLabelAlign">
              <el-form-item label="训练个数:">
                <el-input v-model="formLabelAlign.Number_training"></el-input>
              </el-form-item>
              <el-form-item label="训练时间:">
                <el-input v-model="formLabelAlign.Time_training"></el-input>
              </el-form-item>
            </el-form>
          </div>

          <div class="diceng">
            <el-button type="primary">开始</el-button>
            <el-button>取消</el-button>
          </div>

        </div>
      </div>
    </div>

  </div>
</template>
<script>
export default {
  data() {
    return {
      myDate: new Date(),
      myGameID: "", //游戏ID
      myGameName :"", //游戏名称
      myDiffId: "", // 游戏难度ID
      myDiffType: "", //游戏难度（1：标准，2：自定义）
      myNum: 5, //题目数量
      myStartTime : null, //开始时间
      myEndTime :null, //结束时间
      myRightCount : 0, //正确数
      myRightRate:0,//正确率
      myFaultCount : 0, //错误数
      mySkipQty: 0, //遗漏数
      mySkipQtyRate: 0, //遗漏率
      myTimeCount: 10, //总时间
      myTime: 0, //呈现时间
      myTimer: null, //倒计时
      myTimerStop: null, //倒计时是否结束
      arrayRdm: new Array(), //生成不重复的随机数
      myclickNum: 0, //点击数字
      myStatus: "", //游戏完成的状态
      myTempStr: "0", //临时数据
      myStart: false, //游戏是否开始
      PublishID: 0,
      UserID: null,
      panduan: 1,
      fengeshuju: [],//分割后数据
      judgment: true,//判断提示语和难度选择是否出现
      start_judgment: true,//开始训练和难度选择切换判断
      zidingyi_judgment: true,//开始训练和难度选择切换判断
      mgeColor: true,//标准选择和自定义切换背景色改变
      trbc: 1,//难度选择添加背景色
      pwdColor: false,
      formLabelAlign: {
        Number_training: '',
        Time_training: '',
      },
    }
  },
  mounted() {
    this.arrayRdm = [];
    this.myGenerateRandom(this.myNum);
    this.fenge(this.arrayRdm, this.myNum)
    this.Time(this.myTimeCount);
  },
  methods: {
    pwdbtn() {
      this.mgeColor = false;
      this.pwdColor = true;
      this.zidingyi_judgment = false;
    },
    Bccolor_switch(val) {//难度选择添加背景色
      this.trbc = val;
    },
    mgebtn() {
      this.mgeColor = true;
      this.pwdColor = false;
      this.zidingyi_judgment = true;
    },
    start() {//开始训练
      this.start_judgment = false;
    },
    Startover() {//重新开始
      this.myGenerateRandom(this.myNum);
      this.fenge(this.arrayRdm, this.myNum);
      this.Time(this.myTimeCount);
    },
    Time(time) {
      this.myTime = parseInt(time / 60) + '分' + time % 60 + '秒';
      let timer = setInterval(() => {
        this.myTime = parseInt(time / 60) + '分' + time % 60 + '秒';
        if (time > 0) {
          time--;
        } else {
          clearTimeout(timer);
          this.submit();
        }
      }, 1000)
    },
    submit() {
      // alert("提交函数")
    },
    myLabClick(val, i) {
      if (this.fengeshuju[val][i].num == this.panduan) {
        this.fengeshuju[val][i].sta = "2";
        this.panduan++;
      } else {
        this.fengeshuju[val][i].sta = "3";
        this.Error_number++;
        this.myFaultCount++;
      }
    },
    //随机生成数字，并且不重复
    myGenerateRandom() {
      var myTotalTemp = this.myNum * this.myNum;
      for (var i = 0; ; i++) {
        if (this.arrayRdm.length < myTotalTemp) {
          this.myGetRdm(myTotalTemp);
        }else {
          break;
        }
      }
    },
    myGetRdm(count) {
      var rand = parseInt(Math.random() * count + 1);
      for (var i = 0; i < this.arrayRdm.length; i++) {
        if (rand == 0) {
          return false;
        }
        if (this.arrayRdm[i].num == rand) {
          return false;
        }
      }
      this.arrayRdm.push({ "num": rand, "sta": "1" });
    },
    fenge(arr, N) {
      var result = [];
      for (var i = 0; i < arr.length; i += N) {
        result.push(arr.slice(i, i + N));
      }
      this.fengeshuju = result;
    }
  }
}

</script>

<style>
  .Game_a_type{width: 100%;height: 100%;}
  .Game_a_type td{width: 40px;height: 40px;border: 1px saddlebrown solid;text-align: center;}
  .Game_table{height: 100%;width: 100%;position: relative;}
  .Game_a_type table{position: absolute;top: 0px;left: 0px;right: 0px;bottom: 0px;margin: auto;}
  .Game_a_type .el-row{height: 100%;}
  .Game_a_type .el-col-20{height: 100%;}
  .Game_a_type .el-col-4{height: 100%;}
  .Game_a_type_left{height: 100%;background-image: url('../../assets/div3_left1.png');background-size: 100% 100%;background-color: #C4E8DC;}
  .Game_a_type_right li{margin-top: 15px;}
  .Game_a_type_right{height: 100%;}
  .Game_a_type_right li:nth-child(1){height: 30%;background-image: url('../../assets/div3_right1.png');background-size: 100% 100%;margin-top: 0px;}
  .Game_a_type_right li:nth-child(2){height: 20%;background-image: url('../../assets/div3_right1.png');background-size: 100% 100%;}
  .Game_a_type_right li:nth-child(3){height: calc(50% - 25px);background-image: url('../../assets/div3_right1.png');background-size: 100% 100%;}
  .Game_table td{text-align: center;line-height: 40px;position: relative;}
  .cue{width: 100%;height: 100%;background-color: #C4E8DC;}
  .cue_nav{height: 230px;width: 80%;position: absolute;top:0%;left: 10%;right: 0px;bottom: 0px;margin: auto;}
  .cue_nav_left{height: 100%;width: 317px;float: left; background: url('../../assets/sucai_bg.png');background-size: 100% 100%;}
  .cue_nav_right{height: 100%;width: 100% + 320px;float: left;}
  .cue_nav_right h2{margin-left: 120px;font-size: 24px;}
  .cue_nav_right p{margin-left: 120px;font-size: 16px;margin-top: 20px;}
  .cue_nav_right button{margin-left: 120px;margin-top: 40px;}
  .difficulty{position: relative;height: 100%;width: 100%;}
  .difficulty_bac{width: 50%;height: 450px; background: url('../../assets/difficulty_bg.png');background-size: 100% 100%;position: absolute;top:0%;left: 0px;right: 0px;bottom: 0px;margin: auto;}
  .difficulty .difficulty_x{width: 100%;font-weight: 700;color: #fff;text-align: center;font-size: 20px;padding-top: 10px;}
  .difficulty_standard{border-radius: 5px;width: 42px;height: 91px;position: absolute;top: 110px;left: -20px;background: linear-gradient(90deg, rgb(148, 198, 163) 0%, rgb(147, 198, 162) 70%, rgb(157, 208, 172) 84%, rgb(116, 150, 126) 100%); cursor:pointer}
  .difficulty_standard p{width: 20px;margin-left: 12px;margin-top: 8px;color: #fff;}
  .difficulty_customize{border-radius: 5px;width: 42px;height: 91px;position: absolute;top: 260px;left: -20px;background: linear-gradient(90deg, rgb(148, 198, 163) 0%, rgb(147, 198, 162) 70%, rgb(157, 208, 172) 84%, rgb(116, 150, 126) 100%); cursor:pointer}
  .difficulty_customize p{width: 20px;margin-left: 12px;margin-top: 15px;color: #fff;}
  .myTrTop {line-height: 35px;font-size: 14px;font-weight: 400;color: rgba(177,143,79,1);}
  .difficulty tr{width: 100%;}
  .difficulty .myTdFont{width: 33%;display: inline-block;border: none;height: 30px;    padding-right: 1px;    color: #895311;}
  .difficulty table{display: inline-block;width: 100%;width: 80%;height: 50%;}
  .difficulty table tr{width: 100%;display: inline-block;}
  .difficulty table th{width: 30%;display: inline-block;float: left;}
  .difficulty .myTrTwo{border: 1px solid rgba(191,190,178,1);line-height: 30px;margin-top: 20px;background-color: rgba(216,215,202,1);cursor: pointer;}
  .diceng{width: 200px;height: 80px;position: absolute;left: 0px;right: 0px;top: 0px;bottom: -330px;margin: auto;}
  .Color{background: linear-gradient(90deg,rgba(141,214,183,1) 0%,rgba(116,203,178,1) 70%,rgba(109,211,185,1) 84%,rgba(57,152,130,1) 100%);}
  .Game_a_type  .el-form{width: 60%;margin-left: 20%;margin-top: 15%;}
  .Game_a_type  .Bccolor{background-color: rgb(177, 143, 79);}
</style>
